import {IGeneralSelection, IGeneralDateSelection, IGeneralSelectedPortfolios} from './../../../models/generalSelection';
import { Action } from '@ngrx/store';
export const UPDATE_DATE = 'UPDATE_DATE';
export const UPDATE_ENTITIES = 'UPDATE_ENTITIES';
export const UPDATE_SELECTION = 'UPDATE_SELECTION';
export const UPDATE_SELECTED_PORTFOLIOS = 'UPDATE_SELECTED_PORTFOLIOS';
export const UPDATE_DATE_SELECTION = 'UPDATE_DATE_SELECTION';
export const UPDATE_BASE_URL = 'UPDATE_BASE_URL';
export const UPDATE_CURRENCY = 'UPDATE_CURRENCY';
export const UPDATE_CLIENT_TITLE = 'UPDATE_CLIENT_TITLE';
export const SET_CLIENT_DATA_INITIALISED = 'SET_CLIENT_DATA_INITIALISED';
export const CLEAR_GENERAL_SELECTION = '[General Selection] Clear';

export class UpdateDate implements Action {
    readonly type = UPDATE_DATE;
    constructor(public payload: Date) { }
}
export class UpdateSelection implements Action {
    readonly type = UPDATE_SELECTION;
    constructor(public payload: IGeneralSelection) { }
}
export class UpdateSelectedPortfolios implements Action {
    readonly type = UPDATE_SELECTED_PORTFOLIOS;
    constructor(public payload: IGeneralSelectedPortfolios) { }
}
export class UpdateDateSelection implements Action {
    readonly type = UPDATE_DATE_SELECTION;
    constructor(public payload: IGeneralDateSelection) { }
}
export class UpdateBaseUrl implements Action {
    readonly type = UPDATE_BASE_URL;
    constructor(public payload: string) { }
}
export class UpdateCurrency implements Action {
    readonly type = UPDATE_CURRENCY;
    constructor(public payload: string | number) { }
}
export class UpdateClientTitle implements Action {
    readonly type = UPDATE_CLIENT_TITLE;
    constructor(public payload: string) {}
}
export class SetClientDataInitialised implements Action {
    readonly type = SET_CLIENT_DATA_INITIALISED;
}
export class ClearGeneralSelection implements Action {
    readonly type = CLEAR_GENERAL_SELECTION;
}

export type GeneralSelectionActions = UpdateDate | UpdateDateSelection | UpdateSelection | UpdateSelectedPortfolios
| UpdateBaseUrl | UpdateCurrency | SetClientDataInitialised | ClearGeneralSelection
| UpdateClientTitle;
